const canvas = document.createElement('canvas');

export function calculateTextWidth(value: string, font: string): number {
  const context = canvas.getContext('2d') as CanvasRenderingContext2D;
  context.font = font;
  return Math.ceil(context.measureText(value).width);
}

export function calculateMaxTextWidth(groups: readonly string[], font: string): number {
  const context = canvas.getContext('2d') as CanvasRenderingContext2D;
  context.font = font;

  let charWidths = new Map<string, number>();
  let result = 0;

  for (let group of groups) {
    let max = 0;
    for (let i = 0; i < group.length; i++) {
      let char = group[i];
      let width = charWidths.get(char);
      if (width === undefined)
        width = context.measureText(char).width;
      if (width > max)
        max = width;
    }
    result += max;
  }
  return result;
}
